var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgCategoryApple = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.524,
    d: "M24.8 48.8c13.255 0 24-10.745 24-24S38.055.8 24.8.8s-24 10.745-24 24 10.745 24 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.524,
    d: "M27.5 17.6c3.9-.9 8.4 2.2 8.2 7-.3 5.6-4.1 11.4-7.9 11.6-1.1 0-1.7-1-3.1-1s-2 1-3.1 1c-3.8-.2-7.6-6-7.9-11.6-.3-6 7-9.4 10.9-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.524,
    d: "M24.8 20.2c-.3-3.1.9-4.6 2.1-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.143,
    d: "M22.2 11.1c1.4 1.4 1 4.1 1 4.1s-2.7.4-4.1-1-1-4.1-1-4.1 2.7-.4 4.1 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h49.5v49.5H0z"
  })))));
};
const Memo = /*#__PURE__*/memo(SvgCategoryApple);
export default Memo;